const planAreas = [
  { area: 'Education', icon: 'ri-graduation-cap-line' },
  { area: 'Employment', icon: 'ri-briefcase-line' },
  { area: 'Physical Health', icon: 'ri-heart-pulse-line' },
  { area: 'Mental Wellness', icon: 'ri-mental-health-line' },
  { area: 'Daily Living Skills', icon: 'ri-home-smile-line' },
  { area: 'Recreation', icon: 'ri-run-line' },
  { area: 'Family Connections', icon: 'ri-user-heart-line' },
  { area: 'Cultural Identity', icon: 'ri-global-line' },
  { area: 'Future Planning', icon: 'ri-compass-3-line' },
];

export default function ApproachSection() {
  return (
    <section id="approach" className="py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 mb-20">
          <div>
            <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
              Our Philosophy
            </span>
            <h2 className="heading-font text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
              Relationship <span className="italic text-primary-600">Before</span> Behaviour
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4 font-semibold text-lg">
              Behaviour is communication.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              We believe lasting change begins with trust. Our approach is relationship-based, trauma-informed, and individualized.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-6">
              Rather than asking, &ldquo;What&apos;s wrong with this youth?&rdquo; we ask, &ldquo;What happened to them&mdash;and what do they need to move forward?&rdquo;
            </p>
            <div className="bg-background-50 rounded-xl p-5 border-l-4 border-accent-500">
              <p className="text-foreground-700 text-sm leading-relaxed italic">
                Strong, consistent relationships are widely recognized as one of the core ingredients of effective residential care for young people with experiences of trauma.
              </p>
            </div>
          </div>

          <div>
            <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
              Individualized Care
            </span>
            <h2 className="heading-font text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
              Every Youth Has a <span className="italic text-primary-600">Personalized</span> Success Plan
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              No two youth are alike. Each youth receives an individualized plan focused on their unique goals. Progress is reviewed regularly with placing agencies.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
              {planAreas.map((item) => (
                <div
                  key={item.area}
                  className="flex items-center gap-3 bg-background-50 rounded-lg px-4 py-3 border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-default group"
                >
                  <span className="w-8 h-8 flex items-center justify-center text-accent-600 flex-shrink-0 group-hover:text-accent-700 transition-colors">
                    <i className={`${item.icon} text-sm`}></i>
                  </span>
                  <span className="text-foreground-800 text-sm font-medium label-font">{item.area}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-primary-50/50 rounded-2xl p-8 md:p-12 border border-primary-100/50">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8">
            <div className="flex-shrink-0">
              <span className="w-16 h-16 flex items-center justify-center bg-primary-100 text-primary-600 rounded-2xl">
                <i className="ri-chat-quote-line text-2xl"></i>
              </span>
            </div>
            <div>
              <blockquote className="heading-font text-xl md:text-2xl text-foreground-900 leading-relaxed italic mb-4">
                &ldquo;We don&apos;t define youth by their trauma. We help them discover their strengths. We don&apos;t measure success by how quietly a placement ends. We measure success by who the young person becomes.&rdquo;
              </blockquote>
              <p className="text-foreground-500 text-sm label-font">&mdash; The MCT Difference</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}